export default {
  actions: {
    warning: 'Warning',
    search_fotograms: 'Photograph query',
    tools: 'Tools for selecting photographs',
    view_extend: 'View extension',
    polygons: 'Selection by polygon',
    mtn_sheet: 'Selection by MTN Sheet',
    remove_criteria: 'Remove selection criteria',
    load_selection: 'Load selection',
    available_scale_1: 'This tool is enabled on a scale',
    available_scale_2: 'or in greater detail (province level).',
    sheet_not_found: 'Sheet not found, check the query.',
    select_flight: 'This tool will be enabled when a flight is selected.',
    using_geometry: 'Selection using geometry local file',
    allowed_formats: 'Area selection file (.shp compressed in .zip, .kml, .gpx or .geojson).',
    srs: 'The SRS will be adapted to the viewer.',
  },
  checkbox: {
    select: 'Select',
    quit: 'Remove selection',
  },
  download: {
    name: 'Name',
    surname: 'Surname',
    organization: 'Organization',
    zip_code: 'Postal Code',
    email: 'Email',
    more_quality: `If you need the photographs in high quality, please request them <b class='clickable'>here.</b>`,
    terms_and_conditions: 'Terms and conditions',
    next: 'Next',
    one_by_one: `Click on the following links to <b>download the files one by one:</b>`,
    text_metalink: `Using the <a target='_blank' rel='noopener noreferrer' href='https://es.wikipedia.org/wiki/Metalink'>metalink</a> button, you can download all files with one click using a <a target='_blank' rel='noopener noreferrer' href='http://www.metalinker.org/implementation.html'>compatible download manager</a>`,
    metalink: 'Metalink',
  },
  filters: {
    search_flights: 'Search for flights',
    text: 'Text to search',
    flight_type: 'Flight type',
    select: 'Select',
    date: 'Flight date between',
    search: 'Search',
    clean: 'Clean',
    please: 'Please enter some search criteria.',
    check: 'Check that the flight scale and year are in the correct format.',
    regional: 'Regional',
    infrastructures: 'Infrastructures',
    inside_view: 'Inside the view',
    back: 'Go back',
    and: 'and',
    load_error: 'Failed to load data. Please try again in a few minutes and if the error persists contact us.',
    all_types: 'All types',
    all_typologies: 'All typologies',
    analogic: 'Analogical',
    digital: 'Digital',
    typology: 'Typology',
    colour: 'Colour',
    all_colors: 'All colors',
    select_range: 'Select the range of years over which to perform the search. The second year must be later than the first year.',
  },
  info: {
    fotogram: 'Photograph',
    flight: 'Flight',
    flight_id: 'Identifier',
    name: 'Name',
    date_flight: 'Flight date',
    scale: 'Scale',
    registers_number: 'Registers number',
    color: 'Color',
    fotogram_id: 'Identifier',
    date: 'Date',
    ellipsoid: 'Ellipsoid',
    municipality: 'Municipality',
    zone: 'UTM Zone',
    flight_type: 'Flight type',
    flight_typologoy: 'Flight typology',
    province: 'Province',
    sheet_50: 'MTN50 Sheet',
    sheet_25: 'MTN25 Sheet',
    sheet_05: 'MTN05 Sheet',
    download: 'Download',
    type: 'Type',
    typology: 'Typology',
  },
  list: {
    my_list: 'My photographs list',
    fotograms: 'Photographs',
    opacity: 'Opacity',
    actions: 'Actions',
    selected: 'Selected photographs',
    remove: 'Delete',
    download: 'Download',
    info: 'Photograph Information',
    please_wait: 'Please wait...',
    not_area: 'There is no photograph in the selected area',
    download_fotograms: 'Photographs download',
    compare: 'Compare',
    compare_fotograms: 'Photographs Comparison',
    flight: 'Flight',
    fotogram: 'Photograph',
    error: 'An error occurred while printing. Please try again in a few minutes and if the error persists contact us.',
    download_error: 'An error occurred generating the download links. Please try again in a few minutes and if the error persists contact us.',
    info_error: 'An error occurred querying the photograph metadata. Please try again in a few minutes and if the error persists please contact us.',
  },
  menu: {
    search_on_view: 'Search photographs',
    close: 'Close',
  },
  mtnSelector: {
    grid: 'Grid',
    number: 'Number',
    quarter: 'Quarter',
    show_sheet: 'Show Sheet',
    number_50: 'MTN50 Sheet Number',
  },
  pagination: {
    of: ' of ',
  },
  printSelection: {
    info: 'Information',
    step1: '1. Click on the box.',
    step2: '2. Drag the box to the area.',
    step3: '3. Drop the box.',
    paper: 'Paper',
    scale: 'Scale',
    custom: 'Custom',
    orientation: 'Orientation',
    vertical: 'Vertical',
    horizontal: 'Horizontal',
    request_certificate: 'Request Certificate',
    digital: 'Digital',
    accept: 'Accept',
    certificate_text: 'The printed document with the zone you select will be sent. This certificate has a service cost that once added to the cart, will be managed in the Virtual Store. Select the cart to see your order.',
  },
  results: {
    search_data: 'Consult metadata',
    results: 'Results',
    name: 'Name',
    type: 'Type',
    actions: 'Actions',
    flight_info: 'Flight Information',
    select: 'Select',
    code: 'Code',
    typology: 'Typology',
    to_zoom: 'Go to extension',
  },
  tableRow: {
    fotogram: 'Photograph',
    flight: 'Flight',
    show: 'Show',
    hide: 'Hide',
    info: 'Consult data',
    certify: 'Certify',
    delete: 'Delete',
  },
  visor: {
    wrong_format: 'You have entered a file with an invalid format.',
    no_geom: 'No geometries detected in this file.',
    max_allowed1: 'Files are not supported if they have more than',
    max_allowed2: 'different geometries.',
    area_limit: 'The query area exceeds the allowed limit.',
    error_loading: 'Error loading file. Check that this is the correct file.',
    file: 'File',
    aprox_position: 'approximate position',
    photo: 'Photo',
    sheet: 'MTN50 Sheet',
    flight: 'Flight',
    date: 'Date',
    tools_panel: 'Tools panel',
    lengths: 'Measure distances',
    areas: 'Measure areas',
    delete_measures: 'Remove measures',
    information: 'Consult layers',
    rotate: 'Change viewer orientation',
    scaleline: 'Scale line',
  },
  tree: {
    search: 'Search',
    type_here: 'Type here...',
    clear: 'Clear',
    please_characters: 'Please enter at least 3 characters to perform a search',
  },
};
